<template>
  <div class="tableSonTemp">
    <div
      :style="{
        color: color ? color : '#606266',
      }"
      v-if="data || data === 0"
      class="ellipsisStyle"
      :title="data"
    >
      {{ data }}
    </div>
    <div v-else>-</div>
  </div>
</template>
<script>
export default {
  props: ["data", "config"],
  computed: {
    color() {
      return this.config.rules.baseConfig.color;
    },
  },
};
</script>
